import { screenCaptureSupported } from './screenShare.js';
import { notificationsSupported } from './notifications.js';

/**
 * Which capabilities this browser lacks, for the landing-page recommendation.
 *
 * Deliberately capability-based, never user-agent-based: Edge, Brave, Arc and
 * Opera are Chromium and support both APIs, so sniffing for "Chrome" would nag
 * people whose browsers work perfectly. A capability check also needs no upkeep
 * as UA strings change.
 *
 * The values ARE the display strings — the notice joins them into a list rather
 * than a sentence, which sidesteps singular/plural verb agreement.
 */
export type MissingCapability = 'screen sharing' | 'call notifications';

/** Empty means the browser is fine and the notice renders nothing. */
export function missingCapabilities(): MissingCapability[] {
  const missing: MissingCapability[] = [];
  if (!screenCaptureSupported()) missing.push('screen sharing');
  if (!notificationsSupported()) missing.push('call notifications');
  return missing;
}
